// Service
import FormsService from '../../services/forms.service';
// Reducer
import * as FormReducer from './forms.reducers';

  // Insert Client Partial Registration Data ====================================================================================================

  export const insertarClienteDataParcial = (data) => async (dispatch) => {
    dispatch(FormReducer.setInsertClientpartialDataLoading());

    try {

      const response = await FormsService.insertarClienteDataParcial(data);
      dispatch(FormReducer.setInsertClientpartialDataSuccess(response.data));

    } catch(error) {
      dispatch(FormReducer.setInsertClientpartialDataFailure(error.response?.data?.data?.descripcionError || error.message));
    }

  }

  
  // Consult Client Partial Registration Data ====================================================================================================

  export const clienteDataParcial = (data) => async (dispatch) => {
    dispatch(FormReducer.setConsultClientPartialDataLoading());

    try {

      const response = await FormsService.clienteDataParcial(data);
      dispatch(FormReducer.setConsultClientPartialDataSuccess(response.data));

    } catch(error) {
      dispatch(FormReducer.setConsultClientPartialDataFailure(error.response?.data?.descripcionError || error.message));
    }

  }

  // Cleanup Consult Client Partial Registration Data Store ====================================================================================================

  export const cleanUpClienteDataParcial = () => async (dispatch) => {
    dispatch(FormReducer.cleanUpConsultClientPartialData());
  }

  
  // Consult Existing Client Data ====================================================================================================

  export const clienteExistente = (data) => async (dispatch) => {
    dispatch(FormReducer.setConsultExistingClientDataLoading());

    try {

      const response = await FormsService.clienteExistente(data);
      dispatch(FormReducer.setConsultExistingClientDataSuccess(response.data?.data));

    } catch(error) {
      dispatch(FormReducer.setConsultExistingClientDataFailure(error.response?.data?.data?.descripcionError || error.message));
    }

  }

  // Cleanup Consult Existing Client Data Store ====================================================================================================

  export const cleanUpClienteExistente = () => async (dispatch) => {
    dispatch(FormReducer.cleanUpConsultExistingClientData());
  }

  // Set Consult Form Values ====================================================================================================

  export const handleSetConsultFormValues = (values) => async (dispatch) => {
    dispatch(FormReducer.setConsultFormValues(values));
  }

  // Set Form Values ====================================================================================================

  export const handleSetFormValues = (values) => async (dispatch) => {
    dispatch(FormReducer.setFormValues(values));
  }

 // Set Show Module Intro ====================================================================================================

  export const handleSetShowModuleIntro = (showIntro) => async (dispatch) => {
    dispatch(FormReducer.setShowModuleIntro(showIntro));
  }

  // Set Form Module ====================================================================================================

  export const handleSetModule = (moduleNumber) => async (dispatch) => {
    dispatch(FormReducer.setModule(moduleNumber));
  }

  // Set Form Step ====================================================================================================

  export const handleSetFormStep = (formStep) => async (dispatch) => {
    dispatch(FormReducer.setFormStep(formStep));
  }

  // Reset Form Steps ====================================================================================================

  export const handleResetFormSteps = () => async (dispatch) => {
    dispatch(FormReducer.resetFormSteps());
  }